import gql from 'graphql-tag';

import type { EntityComplianceData } from 'src/data/compliance';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryComplianceForBlogPostDraftArgs } from 'src/types/backend';

import { FRAGMENT_BLOG_DRAFT_COMPLIANCE } from './schema';

const QUERY = gql`
  query ComplianceForBlogDraft($id: ID!) {
    complianceForBlogPostDraft(id: $id) {
      ...BlogDraftCompliance
    }
  }
  ${FRAGMENT_BLOG_DRAFT_COMPLIANCE}
`;

type Variables = BackendQueryComplianceForBlogPostDraftArgs;
type Result = EntityComplianceData;

export const queryComplianceForBlogDraft = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
